import { OndigoNS } from '../modules/main.js';
import { Ondigoform } from '../plugins/ondigoform';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.Overlay = function (element) {
        this.$button = $(element);
        this.$id = this.$button.attr('data-id');
        this.$searchIDText = null;
        this.$searchIDHiddenField = null;
        this.$body = $('body');
        this.$overlay = null;
        this.$overlayContent = null;
        this.$overlayShadow = null;
        this.$overlayForm = null;

        this.init();
    };

    OndigoNS.Overlay.prototype = {
        init: function () {
            var _scope = this,
                url,
                html,
                content,
                whiteOverlay = '';

            this.$button.on('click', function (e) {
                url = '/immobilie-verkaufen/kundengesuche/formular/';
                e.preventDefault();
                e.stopPropagation();

                _scope.$body.addClass('hasOverlay');
                $(e.target).attr('disabled', 'disabled');
                $(e.target).addClass('disabled');

                $('.formOverlay').remove();
                $('.shadow').remove();

                html = '<div class="formOverlay' + whiteOverlay + '"><div class="overlayContent"><span class="loader"></span></div></div><div class="shadow"></div>';
                _scope.$body.append(html);
                _scope.$overlay = $('.formOverlay');
                _scope.$overlayShadow = $('.shadow');
                _scope.$overlayContent = $('.overlayContent', _scope.$overlay);
                _scope.$overlay.fadeIn();
                _scope.$overlayShadow.fadeIn();
                _scope.handleOverlayPosition();

                $.ajax({
                    url: url,
                    type: 'GET',
                    success: function(data){
                        let script = '';
                        let style = '';

                        // load altcha script
                        $(data).each(function(i, el){

                            if(el.tagName === 'SCRIPT' && el.src.indexOf('altcha.js') > -1) {
                                script = el.outerHTML;
                            }

                            if(!!el.href && (el.href.indexOf('altcha.css') > -1 || el.href.indexOf('altcha-form.css') > -1)) {
                                style += el.outerHTML;
                            }
                        });

                        content = $(data).find('.ondigoform').parent().html() + '<span class="remove onIconCloseCircle"></span>';
                        _scope.appendOverlay(style + content + script);
                    }
                });
            });

        },
        appendOverlay: function(html) {
            var _scope = this;

            this.$overlayContent.append(html);
            $('.loader', _scope.$overlayContent).remove();
            this.handleOverlayPosition();

            this.$overlayForm = $('form', this.$overlayContent);
            this.$submitButton = $('.button', this.$overlayForm);
            this.$searchIDText = $('.searchID', this.$overlayForm);
            this.$searchIDHiddenField = $("[id$='contact-objectid']", this.$overlayForm);

            this.$searchIDText.text(this.$id);
            this.$searchIDHiddenField.val(this.$id);

            $('html').addClass('overlayVisible');

            if (this.$overlayForm.length) {
                Ondigoform.Validator.init(this.$overlayForm);
                // Multistep copied from EXT:ondigoform
                _scope.initMultistep(this.$overlayForm);
                $.fn.formEnhancement();

                this.$overlayContent.css('overflow-y', 'scroll');
                this.$overlayContent.css('max-height', '100%');

                this.$overlayForm.on('submit', function (e) {
                    if (!Ondigoform.Validator.validateForm(_scope.$overlayForm)) {
                        e.preventDefault();
                        e.stopPropagation();
                    } else {
                        //_scope.sendData(e);
                    }
                });

            }
            _scope.addListeners();
        },

        initMultistep : function(form) {
            'use strict';

            var $steps = $('.jsFormStep', form),
                $select = $('select'),
                $this,
                $parentRow,
                $textInputs = $('input:not([type="checkbox"]):not([type="submit"]):not([type="hidden"]), textarea', form);

            if (!$steps.length) {
                return;
            }

            $steps.each(function (i, fieldSet) {
                $(fieldSet).hide();
            });
            $steps.first().show();

            $textInputs.on('change keydown keyup', function () {
                $this = $(this);
                $parentRow = $this.parents('.row');
                window.setTimeout(function () {
                    if ($this.val() !== '') {
                        $parentRow.addClass('hasValue');
                    }
                    else {
                        $parentRow.removeClass('hasValue');
                    }
                });
            });

            $textInputs.on('focus', function () {
                $(this).parents('.row').addClass('hasFocus');
            });

            $textInputs.on('blur', function () {
                $(this).parents('.row').removeClass('hasFocus');
            });

            $textInputs.each(function(i, form) {
                $this = $(this);
                $parentRow = $this.parents('.row');
                if ($this.val() !== '') {
                    $parentRow.addClass('hasValue');
                }
                else {
                    $parentRow.removeClass('hasValue');
                }
                $textInputs.parents('.row').find('label').addClass('activatedCssAnimation');
            });

            $select.on('change', function (e) {
                $this = $(this);
                $parentRow = $this.parents('.row');
                $(this).trigger('blur');
                $(this).parents('.row').next().find('input').focus();
                $this.parents('.row').find('label').addClass('activatedCssAnimation');
                window.setTimeout(function () {
                    if ($this.val() !== '') {
                        $parentRow.addClass('hasValue');
                    }
                    else {
                        $parentRow.removeClass('hasValue');
                    }
                });
            });

            $('input, textarea, select', form).not('input:submit, input:button').on('focus', function (e) {
                var placeholder = $(e.currentTarget).attr('placeholder'),
                    placeHolderDetail = $(e.currentTarget).data('placeholder-detail');

                if (placeHolderDetail) {
                    $(e.currentTarget).attr('placeholder', placeHolderDetail);
                }

                $(e.currentTarget).one('focusout', function (e) {
                    $(e.currentTarget).attr('placeholder', placeholder);
                });
            });

            $select.on('focus', function (e) {
                $(e.currentTarget).closest('.selectOverflow').addClass('hasFocus');
            }).on('focusout', function (e) {
                $(e.currentTarget).closest('.selectOverflow').removeClass('hasFocus');
            });

            //reset if user enters the page a second time (firefox)
            $('.fileUploadLabel').val('');

            $('.upload').on('change', function (e) {
                var $row = $(e.currentTarget).closest('.row'),
                    filename = $(e.currentTarget).val().replace(/C:\\fakepath\\/i, ''),
                    $clearInput = $('.clearInput', $row);
                $('.fileUploadLabel', $row).val(filename);
                $clearInput.addClass('visible');
                $clearInput.on('click', function (e) {
                    $('.fileUploadLabel', $row).val('');
                    $('.upload', $row).val('');
                    $clearInput.removeClass('visible');
                });
            });
        },

        initializeNumberPickers : function() {
            var $numberPicker = $('.numberPicker');
            if ($numberPicker.length) {
                $.each($numberPicker, function () {
                    if (!$(this).hasClass('initialized')) {
                        $(this).numberPicker();
                    }
                });
            }
        },
        addListeners: function() {
            var _scope = this;


            this.$overlay.add($('.onIconCloseCircle', this.$overlay).not('.inputWrapper .onIconCloseCircle')).on('click', function (e) {
                if($(e.target).hasClass('formOverlay') || $(e.target).hasClass('onIconCloseCircle')) {
                    e.preventDefault();
                    _scope.$overlay.fadeOut();
                    _scope.$overlayShadow.fadeOut();
                    $('html').removeClass('overlayVisible');
                    _scope.$body.removeClass('noScrolling');
                    _scope.$body.removeClass('hasOverlay');
                    _scope.$button.removeAttr('disabled');
                    _scope.$button.removeClass('disabled');
                }
            });
            this.handleOverlayPosition();
            $(window).on('resize', function () {
                if (_scope.$overlay.length) {
                    _scope.handleOverlayPosition();
                    window.setTimeout(function() {
                        _scope.handleOverlayPosition();
                    }, 100);
                }
            });
        },
        sendData: function (e) {
            var _scope = this,
                $currentTarget = $(e.currentTarget),
                $form = $currentTarget.closest('.ondigoform'),
                $formParent = $form.parent();

            window.setTimeout(function() {
                _scope.handleOverlayPosition();
            }, 200);

            if ($form.find('.hasError').length === 0) {
                _scope.$submitButton.attr('disabled', 'disabled');
                _scope.$submitButton.addClass('disabled');
                _scope.$submitButton.unbind();
                $.ajax({
                    type: 'POST',
                    url: $form.attr('action'),
                    data: $form.serialize(),
                    success: function(data) {
                         $formParent.html($(data).find('.summary'));
                             window.setTimeout(function() {
                             _scope.handleOverlayPosition(); // TODO ondigoform.js must validate the form before the ajax call
                             _scope.$overlayContent.css('overflow-y', 'hidden');
                         });
                    }
                });
            }
        },
        handleOverlayPosition: function () {
            this.$overlayContent.height('');
            $('.innerContent').css('overflow-y', 'visible');
            if ($('.innerContent').height() > 400) {
                this.$overlayContent.height('450px');
                $('.innerContent').css('overflow-y', 'scroll');
            }

            var margin = ($(window).outerHeight() - this.$overlayContent.outerHeight()) / 2;

            if (margin > 0) {
                this.$overlayContent.css({
                    margin:  margin + 'px auto'
                });
            }
            else {
                this.$overlayContent.css({
                    margin: '0 auto'
                });
            }
        }
    };
    // plugin definition
    $.fn.overlay = function () {
        return new OndigoNS.Overlay(this);
    };
    $.fn.overlay.Constructor = OndigoNS.Overlay;

}(window.jQuery));


$(document).ready(function () {
    'use strict';

    window.setTimeout(function() {
        var $openOverlay = $('.openOverlay');
        if ($openOverlay.length) {
            $.each($openOverlay, function () {
                $(this).overlay();
            });
        }
    }, 200);

});
